import { createRouter, createWebHistory } from "vue-router";
import MainLayout from "../pages/layout/MainLayout.vue";
import Login from "../pages/Login.vue";
import SignUp from "../pages/SignUp.vue";
import Dashboard from "../pages/Dashboard.vue";
import Show from "../pages/Campaigns/Show.vue";
import Add from "../pages/Campaigns/Add.vue";
import FreeTrialAdd from "../pages/Campaigns/FreeTrialAdd.vue";
import Statistics from "../pages/Statistics/Statistics.vue";
import Reports from "../pages/Reports/Reports.vue";
import Support from "../pages/Support/Support.vue";
import Profile from "../pages/Profile/Profile.vue";
import ContentLibrary from "../pages/Content/ContentLibrary.vue";
import store from "../store/index";
import Tracking from "../pages/Tracking/Tracking.vue";
import Leaderboard from "../pages/Tracking/Leaderboard.vue";
import Screens from "../pages/Tracking/Screens.vue";

const routes = [
    {
        path: "/",
        component: MainLayout,
        children: [
            { name: "", path: "/", component: Dashboard },
            { name: "", path: "/campaigns", component: Show },
            {
                name: "New Campaign",
                path: "/add-campaign",
                component: Add,
            },
            {
                name: "Free Trial Campaign",
                path: "/free-campaign",
                component: FreeTrialAdd,
            },
            { name: "", path: "/reports", component: Reports },
            { name: "", path: "/tracking", component: Tracking },
            { name: "", path: "/leaderboard", component: Leaderboard },
            { name: "", path: "/screens", component: Screens },

            { name: "", path: "/support", component: Support },
            { name: "", path: "/statistics", component: Statistics },
            { name: "", path: "/profile", component: Profile },
            // { name: "Content Library", path: "/content-library", component: ContentLibrary },
        ],
    },
    { name: "Login", path: "/login", component: Login },
    { name: "SignUp", path: "/sign-up", component: SignUp },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.path === "/login" || to.path === "/sign-up") {
        next();
    } else {
        if (localStorage.getItem('token') === null) {
            next("/login");
        } else {
            next();
        }
    }
});

export default router;
